<script lang="ts">
    import { onMount } from "svelte";

    let show = false;

    onMount(() => {
        if (localStorage.getItem("visited") === "true") {
            show = false;
        } else {
            show = true;
            localStorage.setItem("visited", "true");
        }
    });
</script>

{#if show}
    <div class="flex flex-col items-end m-4">
        <div class="bg-black text-white p-4">
            <div class="flex flex-row justify-between">
                <h1 class="text-xl font-medium">Welcome!</h1>
                <p
                    class="text-button hoverable"
                    on:click={() => {
                        show = false;
                    }}
                >
                    x
                </p>
            </div>
            <p>
                Use the arrows below or the command prompt to navigate the
                website's pages...
            </p>
        </div>
        <span
            class="w-0 h-0"
            style="
            border-left: 20px solid transparent;
            border-right: 20px solid transparent;
            border-top: 20px solid #000;
        "
        />
    </div>
{/if}
